<template>
  <div class="sarai-dashboard">
    <vx-card class="w-full mb-10 " >
      <div v-if="loading" class="text-center p-8">
        <vs-progress indeterminate color="primary"></vs-progress>
        <p class="mt-4">Loading dashboard data...</p>
      </div>

      <div v-else>
        <!-- Total Sarai & Commission Statistics -->
        <div class="mb-6 grid grid-cols-7 gap-6">
          <div class="col-span-3">
            <h4 class="font-semibold text-xl dashboard-heading mb-4">Statistics</h4>
            <div class="sarai-stat-panel rounded-lg shadow-md px-6 py-12 border">
              <div class="flex items-center gap-16">
                <!-- Total Sarai -->
                <div class="flex items-center gap-4">
                  <div style="background-color: #f5f3ff !important" class="stat-icon-container rounded-lg p-3 flex-shrink-0">
                    <feather-icon icon="HomeIcon" style="color: #6366f1 !important" svgClasses="w-6 h-6" />
                  </div>
                  <div class="flex-1">
                    <h3 class="text-3xl font-bold dashboard-heading mb-1">{{ formatNumber(dashboardData.total_sarai || 0) }}</h3>
                    <p class="text-gray-600 text-base font-medium">Total Sarai</p>
                  </div>
                </div>

                <!-- Commission -->
                <!-- <div class="flex items-center gap-4">
                  <div style="background-color: #f5f3ff !important" class="stat-icon-container rounded-lg p-3 flex-shrink-0">
                    <feather-icon style="color: #3b82f6 !important" icon="TrendingUpIcon" svgClasses="w-6 h-6" />
                  </div>
                  <div class="flex-1">
                    <h3 class="text-3xl font-bold text-gray-800 mb-1">₹ {{ formatCurrency(dashboardData.commission || 0) }}</h3>
                    <p class="text-gray-600 text-base font-medium">Commission</p>
                  </div>
                </div> -->

                <!-- Total Rooms -->
                <div class="flex items-center gap-4">
                  <div style="background-color: #f5f3ff !important" class="stat-icon-container rounded-lg p-3 flex-shrink-0">
                    <feather-icon icon="LayersIcon" style="color: #10b981 !important" svgClasses="w-6 h-6" />
                  </div>
                  <div class="flex-1">
                    <h3 class="text-3xl font-bold dashboard-heading mb-1">{{ formatNumber(dashboardData.room_statistics ? dashboardData.room_statistics.total_rooms : 0) }}</h3>
                    <p class="text-gray-600 text-base font-medium">Total Rooms</p>
                  </div>
                </div>

                <!-- Total Bookings -->
                <div class="flex items-center gap-4">
                  <div style="background-color: #f5f3ff !important" class="stat-icon-container rounded-lg p-3 flex-shrink-0">
                    <feather-icon icon="CalendarIcon" style="color: #f59e0b !important" svgClasses="w-6 h-6" />
                  </div>
                  <div class="flex-1">
                    <h3 class="text-3xl font-bold dashboard-heading mb-1">{{ formatNumber(dashboardData.booking_statistics ? dashboardData.booking_statistics.total_bookings : 0) }}</h3>
                    <p class="text-gray-600 text-base font-medium">Total Bookings</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Income Statistics -->
          <div class="col-span-4">
            <h4 class="font-semibold mb-4 text-xl">Income Statistics</h4>
            <div class="grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
              
              <!-- Rejected -->
              <div class="income-stat-card income-stat-card-red rounded-lg p-6 shadow-md">
                <div class="flex items-center justify-between mb-4">
                  <div class="icon-container bg-red-100 rounded-lg">
                    <p style="color: #ef4444 !important" class="text-base font-semibold">Rejected</p>
                  </div>
                </div>
                <h3 class="text-3xl font-bold dashboard-heading mb-2">₹ {{ formatCurrency(dashboardData.revenue_statistics ? dashboardData.revenue_statistics.rejected_revenue : 0) }}</h3>
                <p class="text-gray-500 income-booking">{{ dashboardData.booking_statistics ? dashboardData.booking_statistics.rejected_bookings : 0 }} Bookings</p>
              </div>
              <!-- Pending -->
              <div class="income-stat-card income-stat-card-yellow rounded-lg p-6 shadow-md">
                <div class="flex items-center justify-between mb-4">
                  <div class="icon-container bg-yellow-100 rounded-lg">
                    <p style="color: #eab308 !important" class="text-base font-semibold">Pending</p>
                  </div>
                </div>
                <h3 class="text-3xl font-bold dashboard-heading mb-2">₹ {{ formatCurrency(dashboardData.revenue_statistics ? dashboardData.revenue_statistics.pending_revenue : 0) }}</h3>
                <p class="text-gray-500 income-booking">{{ dashboardData.booking_statistics ? dashboardData.booking_statistics.pending_bookings : 0 }} Bookings</p>
              </div>

              <!-- Cancelled -->
              <div class="income-stat-card income-stat-card-red rounded-lg p-6 shadow-md">
                <div class="flex items-center justify-between mb-4">
                  <div class="icon-container bg-red-100 rounded-lg">
                    <p style="color: #ef4444 !important" class="text-base font-semibold">Cancelled</p>
                  </div>
                </div>
                <h3 class="text-3xl font-bold dashboard-heading mb-2">₹ {{ formatCurrency(dashboardData.revenue_statistics ? dashboardData.revenue_statistics.cancelled_revenue : 0) }}</h3>
                <p class="text-gray-500 income-booking">{{ dashboardData.booking_statistics ? dashboardData.booking_statistics.cancelled_bookings : 0 }} Bookings</p>
              </div>
             
            </div>
            </div>
          </div>
        <!-- Statistics Charts Section -->
        <div class="mb-6 mt-8">
          <div class="grid sm:grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Room Statistics Chart -->
            <div>
              <div class="rounded-lg shadow-md p-6 chart-card">
                <div class="flex justify-between items-start mb-6">
                  <div>
                    <h4 class="font-semibold text-xl dashboard-heading mb-1">Room Statistics</h4>
                    <p class="text-gray-500 text-base">Total rooms: {{ formatNumber(roomStatsData.total_rooms || 0) }}</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <select-2
                      class="w-36"
                      name="room-month"
                      placeholder="Month"
                      :options="monthOptions"
                      :multiple="false"
                      :ssr="false"
                      :clearable="false"
                      :value="selectedMonth"
                      @input="onMonthChange"
                    />
                    <select-2 class="w-28" name="room-year" placeholder="Year" :options="yearOptions" :multiple="false" :ssr="false" :clearable="false" :value="selectedYear" @input="onYearChange" />
                  </div>
                </div>

                <div v-if="roomStatsLoading" class="text-center py-8">
                  <vs-progress indeterminate color="primary"></vs-progress>
                  <p class="mt-4 text-gray-600 text-sm">Loading room statistics...</p>
                </div>

                <div v-else>
                  <vue-apex-charts type="line" height="350" :options="roomChartOptions" :series="roomChartSeries"></vue-apex-charts>
                </div>
              </div>
            </div>

            <!-- Revenue Statistics Chart -->
            <div>
              <div class="rounded-lg shadow-md p-6 chart-card">
                <div class="flex justify-between items-start mb-6">
                  <div>
                    <h4 class="font-semibold text-xl dashboard-heading mb-1">Revenue Statistics</h4>
                    <p class="text-gray-500 text-base">Total revenue: ₹ {{ formatCurrency(revenueStatsData.total_revenue || 0) }}</p>
                  </div>
                  <div class="flex items-center gap-2">
                    <select-2
                      class="w-36"
                      name="revenue-month"
                      placeholder="Month"
                      :options="monthOptions"
                      :multiple="false"
                      :ssr="false"
                      :clearable="false"
                      :value="selectedRevenueMonth"
                      @input="onRevenueMonthChange"
                    />
                    <select-2
                      class="w-28"
                      name="revenue-year"
                      placeholder="Year"
                      :options="yearOptions"
                      :multiple="false"
                      :ssr="false"
                      :clearable="false"
                      :value="selectedRevenueYear"
                      @input="onRevenueYearChange"
                    />
                  </div>
                </div>

                <div v-if="revenueStatsLoading" class="text-center py-8">
                  <vs-progress indeterminate color="primary"></vs-progress>
                  <p class="mt-4 text-gray-600 text-sm">Loading revenue statistics...</p>
                </div>

                <div v-else>
                  <vue-apex-charts type="area" height="350" :options="revenueChartOptions" :series="revenueChartSeries"></vue-apex-charts>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  components: {
    VueApexCharts,
    'select-2': Select2
  },
  data() {
    const now = new Date()
    const currentMonth = now.getMonth() + 1
    const currentYear = now.getFullYear()

    return {
      loading: false,
      roomStatsLoading: false,
      revenueStatsLoading: false,
      selectedMonth: currentMonth,
      selectedYear: currentYear,
      selectedRevenueMonth: currentMonth,
      selectedRevenueYear: currentYear,
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      years: [],
      monthOptions: [],
      yearOptions: [],
      roomStatsData: {
        total_rooms: 0,
        daily_statistics: []
      },
      revenueStatsData: {
        total_revenue: 0,
        confirmed_revenue: 0,
        pending_revenue: 0,
        completed_revenue: 0,
        cancelled_revenue: 0,
        daily_statistics: []
      },
      dashboardData: {
        total_sarai: 0,
        booking_statistics: {
          total_bookings: 0,
          confirmed_bookings: 0,
          pending_bookings: 0,
          cancelled_bookings: 0,
          completed_bookings: 0
        },
        revenue_statistics: {
          total_revenue: 0,
          confirmed_revenue: 0,
          pending_revenue: 0,
          cancelled_revenue: 0,
          completed_revenue: 0
        },
        room_statistics: {
          total_rooms: 0,
          booked_rooms: 0,
          available_rooms: 0,
          occupancy_rate: 0
        },
        platform_fee: 0,
        commission: 0
      },
      platForm_fee: 0
    }
  },
  computed: {
    isDarkTheme() {
      return this.$store.state.theme === 'dark'
    },
    chartAxisColor() {
      return this.isDarkTheme ? '#cccccc' : '#6b7280'
    },
    chartGridColor() {
      return this.isDarkTheme ? '#333333' : '#e5e7eb'
    },
    selectedMonthName() {
      return this.months[this.selectedMonth - 1] || 'January'
    },
    roomChartSeries() {
      if (!this.roomStatsData.daily_statistics || this.roomStatsData.daily_statistics.length === 0) {
        return [
          {
            name: 'Total Rooms',
            type: 'column',
            data: []
          },
          {
            name: 'Booked Rooms',
            type: 'line',
            data: []
          },
          {
            name: 'Available Rooms',
            type: 'line',
            data: []
          }
        ]
      }

      return [
        {
          name: 'Total Rooms',
          type: 'column',
          data: this.roomStatsData.daily_statistics.map((day) => day.total_rooms)
        },
        {
          name: 'Booked Rooms',
          type: 'line',
          data: this.roomStatsData.daily_statistics.map((day) => day.booked_rooms)
        },
        {
          name: 'Available Rooms',
          type: 'line',
          data: this.roomStatsData.daily_statistics.map((day) => day.available_rooms)
        }
      ]
    },
    roomChartOptions() {
      const categories =
        this.roomStatsData.daily_statistics && this.roomStatsData.daily_statistics.length > 0
          ? this.roomStatsData.daily_statistics.map((day) => {
            const date = new Date(day.date)
            return `${date.getDate()} ${this.months[date.getMonth()].substring(0, 3)}`
          })
          : []

      return {
        chart: {
          type: 'line',
          height: 350,
          toolbar: {
            show: false
          }
        },
        stroke: {
          width: [0, 3, 3],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '60%',
            borderRadius: 4
          }
        },
        colors: ['#f97316', '#8b5cf6', '#10b981'], // Orange for bars, Purple and Green for lines
        fill: {
          type: ['solid', 'solid', 'solid'],
          opacity: [0.8, 1, 1]
        },
        markers: {
          size: [0, 5, 5],
          hover: {
            size: [0, 7, 7]
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          labels: {
            colors: this.chartAxisColor
          },
          markers: {
            width: 10,
            height: 10,
            radius: 5
          },
          itemMargin: {
            horizontal: 20,
            vertical: 5
          }
        },
        xaxis: {
          categories,
          labels: {
            style: {
              colors: this.chartAxisColor,
              fontSize: '12px'
            }
          },
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: this.chartAxisColor,
              fontSize: '12px'
            },
            formatter: (value) => {
              return Math.round(value)
            }
          }
        },
        grid: {
          borderColor: this.chartGridColor,
          strokeDashArray: 4,
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false
        }
      }
    },
    revenueChartSeries() {
      if (!this.revenueStatsData.daily_statistics || this.revenueStatsData.daily_statistics.length === 0) {
        return [
          {
            name: 'Total Revenue',
            data: []
          },
          {
            name: 'Confirmed Revenue',
            data: []
          },
          {
            name: 'Completed Revenue',
            data: []
          }
        ]
      }

      return [
        {
          name: 'Total Revenue',
          data: this.revenueStatsData.daily_statistics.map((day) => day.total_revenue)
        },
        {
          name: 'Confirmed Revenue',
          data: this.revenueStatsData.daily_statistics.map((day) => day.confirmed_revenue)
        },
        {
          name: 'Completed Revenue',
          data: this.revenueStatsData.daily_statistics.map((day) => day.completed_revenue)
        }
      ]
    },
    revenueChartOptions() {
      const categories =
        this.revenueStatsData.daily_statistics && this.revenueStatsData.daily_statistics.length > 0
          ? this.revenueStatsData.daily_statistics.map((day) => {
            const date = new Date(day.date)
            return `${date.getDate()} ${this.months[date.getMonth()].substring(0, 3)}`
          })
          : []

      return {
        chart: {
          type: 'area',
          height: 350,
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.3,
            stops: [0, 90, 100]
          }
        },
        colors: ['#10b981', '#3b82f6', '#6366f1'], // Green, Blue, Indigo
        markers: {
          size: 4,
          hover: {
            size: 6
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          position: 'bottom',
          horizontalAlign: 'center',
          labels: {
            colors: this.chartAxisColor
          },
          markers: {
            width: 10,
            height: 10,
            radius: 5
          },
          itemMargin: {
            horizontal: 20,
            vertical: 5
          }
        },
        xaxis: {
          categories,
          labels: {
            style: {
              colors: this.chartAxisColor,
              fontSize: '12px'
            }
          },
          axisBorder: {
            show: false
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: this.chartAxisColor,
              fontSize: '12px'
            },
            formatter: (value) => {
              if (value >= 100000) {
                return `₹${  (value / 100000).toFixed(1)  }L`
              } else if (value >= 1000) {
                return `₹${  (value / 1000).toFixed(1)  }k`
              }
              return `₹${  Math.round(value)}`
            }
          }
        },
        grid: {
          borderColor: this.chartGridColor,
          strokeDashArray: 4,
          xaxis: {
            lines: {
              show: false
            }
          },
          yaxis: {
            lines: {
              show: true
            }
          }
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: (value) => {
              return `₹${  this.formatCurrency(value)}`
            }
          }
        }
      }
    }
  },
  methods: {
    formatNumber(num) {
      if (num >= 1000) {
        return `${(num / 1000).toFixed(1)  }k`
      }
      return num.toString()
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2
      }).format(amount)
    },
    async fetchDashboardData() {
      this.loading = true
      try {
        const res = await this.$http.get('admin/sarai/dashboard/overall')
        if (res && res.data && res.data.data) {
          this.dashboardData = res.data.data
          this.platForm_fee = res.data.data.platform_fee || 0
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load dashboard data',
          color: 'danger',
          position: 'top-center',
          time: 2500
        })
        console.error('Dashboard fetch error:', error)
      } finally {
        this.loading = false
      }
    },
    async refreshData() {
      await this.fetchDashboardData()
      await this.fetchRoomStatistics()
      await this.fetchRevenueStatistics()
      this.$vs.notify({
        title: 'Success',
        text: 'Data refreshed successfully',
        color: 'success',
        position: 'top-center',
        time: 2000
      })
    },
    async loadPlatformFee() {
      try {
        const res = await this.$http.get('admin/platform-fee/details')
        const data = (res && res.data && res.data.data) || {}
        const value = data.platForm_fee != null ? data.platForm_fee : null
        if (value != null) this.platForm_fee = Number(value)
      } catch (error) {
        // Platform fee UI is currently hidden; do not surface this error
      }
    },
    async save_changes() {
      const feeValue = Number(this.platForm_fee)
      if (Number.isNaN(feeValue) || feeValue < 0) {
        this.$vs.notify({
          title: 'Invalid value',
          text: 'Please enter a valid non-negative number',
          color: 'warning',
          position: 'top-center',
          time: 2200
        })
        return
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm change',
        text: `Are you sure you want to change the platform fee to ${feeValue}%?`,
        acceptText: 'Yes, update',
        cancelText: 'Cancel',
        accept: async () => {
          try {
            const res = await this.$http.post('admin/platform-fee/create-update', { platForm_fee: feeValue })
            const message = (res && res.data && res.data.message) || 'Platform fee updated'
            this.$vs.notify({
              title: 'Success',
              text: message,
              color: 'success',
              position: 'top-center',
              time: 2000
            })
            await this.loadPlatformFee()
            await this.fetchDashboardData() // Refresh dashboard to update commission
          } catch (error) {
            const message = (error && error.message) || 'Failed to update platform fee'
            this.$vs.notify({
              title: 'Error',
              text: message,
              color: 'danger',
              position: 'top-center',
              time: 2800
            })
          }
        }
      })
    },
    async fetchRoomStatistics() {
      this.roomStatsLoading = true
      try {
        const res = await this.$http.get('admin/sarai/dashboard/daily-room-statistics', {
          params: {
            month: this.selectedMonth,
            year: this.selectedYear
          }
        })
        if (res && res.data && res.data.data) {
          this.roomStatsData = res.data.data
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load room statistics',
          color: 'danger',
          position: 'top-center',
          time: 2500
        })
        console.error('Room statistics fetch error:', error)
      } finally {
        this.roomStatsLoading = false
      }
    },
    initializeYears() {
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth() + 1
      const years = []
      // Only show years up to current year (no future years)
      for (let i = currentYear - 2; i <= currentYear; i++) {
        years.push(i)
      }
      this.years = years

      // Initialize month options for Select2
      // For current year, only show months up to current month
      this.monthOptions = this.months.map((month, index) => {
        const monthValue = index + 1
        // If it's the current year, disable future months
        const isFutureMonth = this.selectedYear === currentYear && monthValue > currentMonth
        return {
          label: month,
          value: monthValue,
          disabled: isFutureMonth
        }
      })

      // Initialize year options for Select2
      this.yearOptions = years.map((year) => ({
        label: String(year),
        value: year
      }))
    },
    onMonthChange(item) {
      if (item && item.value) {
        this.selectedMonth = item.value
        // Update month options when year changes to handle future month restrictions
        this.updateMonthOptions()
        this.fetchRoomStatistics()
      }
    },
    onYearChange(item) {
      if (item && item.value) {
        this.selectedYear = item.value
        // Update month options when year changes to handle future month restrictions
        this.updateMonthOptions()
        // If selected month is in the future, reset to current month
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth() + 1
        if (item.value === currentYear && this.selectedMonth > currentMonth) {
          this.selectedMonth = currentMonth
        }
        this.fetchRoomStatistics()
      }
    },
    updateMonthOptions() {
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth() + 1
      this.monthOptions = this.months.map((month, index) => {
        const monthValue = index + 1
        const isFutureMonth = this.selectedYear === currentYear && monthValue > currentMonth
        return {
          label: month,
          value: monthValue,
          disabled: isFutureMonth
        }
      })
    },
    async fetchRevenueStatistics() {
      this.revenueStatsLoading = true
      try {
        const res = await this.$http.get('admin/sarai/dashboard/daily-revenue-statistics', {
          params: {
            month: this.selectedRevenueMonth,
            year: this.selectedRevenueYear
          }
        })
        if (res && res.data && res.data.data) {
          this.revenueStatsData = res.data.data
          // Debug: Log received data
          console.log('[Frontend] Revenue Stats Data:', {
            total_revenue: this.revenueStatsData.total_revenue,
            daily_count: this.revenueStatsData.daily_statistics.length,
            sample_days: this.revenueStatsData.daily_statistics.slice(0, 3)
          })
        }
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load revenue statistics',
          color: 'danger',
          position: 'top-center',
          time: 2500
        })
        console.error('Revenue statistics fetch error:', error)
      } finally {
        this.revenueStatsLoading = false
      }
    },
    onRevenueMonthChange(item) {
      if (item && item.value) {
        this.selectedRevenueMonth = item.value
        this.updateMonthOptions()
        this.fetchRevenueStatistics()
      }
    },
    onRevenueYearChange(item) {
      if (item && item.value) {
        this.selectedRevenueYear = item.value
        this.updateMonthOptions()
        // If selected month is in the future, reset to current month
        const currentYear = new Date().getFullYear()
        const currentMonth = new Date().getMonth() + 1
        if (item.value === currentYear && this.selectedRevenueMonth > currentMonth) {
          this.selectedRevenueMonth = currentMonth
        }
        this.fetchRevenueStatistics()
      }
    }
  },
  async mounted() {
    this.initializeYears()
    await this.fetchDashboardData()
    await this.fetchRoomStatistics()
    await this.fetchRevenueStatistics()
  }
}
</script>

<style lang="scss" scoped>
.vx-card {
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.text-base {
  font-size: 16px !important;
}

.sarai-stat-panel,
.income-stat-card,
.chart-card {
  background-color: var(--card-bg);
  border-color: var(--divider);
}

.dashboard-heading {
  color: var(--text-primary) !important;
}

.income-stat-card {
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  border-bottom: 4px solid transparent;
}

.income-stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.income-stat-card-green {
  border-bottom-color: #10b981 !important; /* green-500 */
}

.income-stat-card-blue {
  border-bottom-color: #3b82f6 !important; /* blue-500 */
}

.income-stat-card-yellow {
  border-bottom-color: #eab308 !important; /* yellow-500 */
}

.income-stat-card-red {
  border-bottom-color: #ef4444 !important; /* red-500 */
}

.income-stat-card-indigo {
  border-bottom-color: #6366f1 !important; /* indigo-500 */
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.income-booking {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: var(--text-secondary) !important;
}

.stat-icon-container {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-card {
  transition: all 0.3s ease;
  border: 1px solid var(--divider);
}

.chart-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.select-filter {
  min-width: 120px;
}
</style>
